import React, { useContext } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ProductContext } from '../../context/ProductContext';
import { CartContext } from '../../context/CartContext';
import { FaArrowLeft, FaHeart, FaShare, FaGem, FaShippingFast, FaShieldAlt } from 'react-icons/fa';
import './ProductDetail.css';

const ProductDetailPage = () => {
  const { id } = useParams();
  const { products } = useContext(ProductContext);
  const { addToCart } = useContext(CartContext);
  
  const product = products.find(p => p.id === parseInt(id));

  if (!product) {
    return (
      <div className="product-not-found">
        <div className="not-found-icon">💎</div>
        <h2>Product Not Found</h2>
        <p>Sorry, we couldn't find the jewellery piece you're looking for.</p>
        <Link to="/shop" className="back-link">Return to Shop</Link>
      </div>
    );
  }

  return (
    <div className="product-detail-page">
      <Link to="/shop" className="back-link">
        <FaArrowLeft /> Back to Shop
      </Link>

      <div className="product-detail-container">
        <div className="product-detail-image">
          <img 
            src={product.image} 
            alt={product.name} 
            className="detail-img"
          />
          {product.tag && <span className="detail-tag">{product.tag}</span>}
        </div>
        
        <div className="product-detail-info">
          <div className="detail-category">{product.category?.toUpperCase() || 'Jewellery'}</div>
          <h1 className="detail-title">{product.name}</h1>
          
          <div className="detail-rating">
            {'★'.repeat(Math.floor(product.rating))}
            {'☆'.repeat(5 - Math.floor(product.rating))}
            <span className="rating-count">({product.rating} / 5)</span>
          </div>
          
          <p className="detail-price">{product.price}</p>
          
          <div className="detail-description">
            <p>
              Discover this exquisite {product.name.toLowerCase()} from our exclusive 
              {product.category === 'gold' ? ' 24K Gold Plated' : ' Sterling Silver'} collection. 
              Crafted with premium quality materials and meticulous attention to detail, 
              this piece embodies the perfect blend of traditional elegance and modern style.
            </p>
            <p className="detail-highlights">
              <span>✨ Premium Quality</span>
              <span>🔒 Anti-Tarnish Finish</span>
              <span>💎 Hypoallergenic</span>
            </p>
          </div>

          <div className="detail-features">
            <div className="feature-item">
              <FaShippingFast />
              <span>Free Shipping</span>
            </div>
            <div className="feature-item">
              <FaShieldAlt />
              <span>Secure Payment</span>
            </div>
            <div className="feature-item">
              <FaGem />
              <span>Premium Quality</span>
            </div>
          </div>
          
          <div className="detail-actions">
            <button 
              className="add-to-cart-btn detail-add-btn"
              onClick={() => addToCart(product)}
            >
              Add to Cart
            </button>
            <button className="wishlist-detail-btn">
              <FaHeart /> Wishlist
            </button>
            <button className="share-detail-btn">
              <FaShare /> Share
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailPage;